
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
  selector: 'app-planilha-input-diretos-lcb-extra',
  templateUrl: './planilha-input-diretos-lcb-extra.component.html',
  styleUrls: ['./planilha-input-diretos-lcb-extra.component.css'],
  standalone: false
})
export class PlanilhaInputDiretosLcbExtraComponent {
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  // query: string = 'itens_Interplantas_Karrara';
  queryDiretasLcbExtras: string = "Viagens-LCB-Diretas-Extras";
  // queryDiretasLcb: string = "Viagens-LCB-Diretas";
  queryFornecedores: string = 'Tb_Suppliers';
  queryTimeTable: string = 'janelasTimeTable';
  queryMPs: string = 'Tb_Suppliers';
  startDate!: Date;
  endDate: Date = new Date();
  editMode!: boolean[];
  informationMode!: boolean[];
  dialogOpen!: boolean;
  places!: any[];
  mps!: any[];
  transportadora!: string[];
  locais!: string[];
  isLoading: boolean = true;
  viagensDiretas!: any[];
  viagensDiretasExtras: any[] = [];
  inputViagens: any[] = [];
  horarios: string[] = [
    "06:00",
    "06:00",
    "07:00",
    "07:00",
    "07:00",
    "08:00",
    "08:00",
    "08:00",
    "09:00",
    "09:00",
    "10:00",
    "10:00",
    "11:00",
    "11:00",
    "12:00",
    "12:00"
  ];
  dataReferencia!: Date;
  dataFormatada!: string;
  viagensDiretasExtrasFiltrados!: any[];
  viagensDiretasExtrasZerada!: any[];
  item: any = {};
  usuarioLogado!: UsuarioLogado;
  filtro: boolean = false;
  desabilitado: boolean = false;
  totalMU: number = 0;
  totalFornecedores: number = 0;
  isAdminEnabled: boolean = false;
  isUserEnabled: boolean = false;
  isCarrierEnabled: boolean = false;
  isMpEnabled: boolean = false;

  constructor(
    private dynamodbService: ApiService,
    public dialog: MatDialog,
    private autenticacaoService: AutenticacaoService
  ) { }

  async ngOnInit() {
    this.usuarioLogado = await this.getUserLogado();
    await this.enableFields();
    await this.upDate();
  }

  async upDate() {
    let dataAtual = new Date();
    await this.resetaVariavel(dataAtual);
    // await this.getDiretas();
    await this.getDiretasExtras();
    await this.getPlacesFromDynamoDB();
    await this.getMPsFromDynamoDB();
    await this.somaMU();
    this.isLoading = false;
  }

  resetaVariavel(data: Date) {
    this.viagensDiretasExtrasZerada = []
    let dataAtual = data;
    // console.log(data)
    if (this.filtro) {
      // console.log('this.filtro')
      this.dataReferencia = new Date(dataAtual);
      this.dataReferencia.setDate(dataAtual.getDate());
      const ano = this.dataReferencia.getFullYear();
      const mes = String(this.dataReferencia.getMonth() + 1).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
      const dia = String(this.dataReferencia.getDate()).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
      this.dataFormatada = `${ano}-${mes}-${dia}`;
    } else {
      // let dataAtual = new Date();
      const horaAtual = dataAtual.getHours();
      if (horaAtual < 15) {
        this.dataReferencia = new Date(dataAtual);
        this.dataReferencia.setDate(dataAtual.getDate());
        const ano = this.dataReferencia.getFullYear();
        const mes = String(this.dataReferencia.getMonth() + 1).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        const dia = String(this.dataReferencia.getDate()).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        this.dataFormatada = `${ano}-${mes}-${dia}`;
      } else {
        // Se a hora atual for após as 15:00, this.dataReferencia é dois dias após a data atual
        this.dataReferencia = new Date(dataAtual);
        this.dataReferencia.setDate(dataAtual.getDate() + 1);
        const ano = this.dataReferencia.getFullYear();
        const mes = String(this.dataReferencia.getMonth() + 1).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        const dia = String(this.dataReferencia.getDate()).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        this.dataFormatada = `${ano}-${mes}-${dia}`;
      }
    }
    for (let i = 0; i < 16; i++) {
      this.viagensDiretasExtrasZerada.push({
        dataSolicitacao: this.dataFormatada,
        horaJanela: this.horarios[i],
        mpCode: '',
        mpName: '',
        codFronecedor: '',
        fornecedor: '',
        volumes: '',
        localRecebimento: 'RECSIDER',
        status: 'NOT OK',
        indice: i // Certifique-se de adicionar o índice ao novo item
      });
    }
    // console.log(this.viagensDiretasExtrasZerada)

  }

  editDialog(item: any, i: number): void {
    // console.log(item)
    // let dataSolicitacaoAux = new Date(item.dataSolicitacao)
    let dataAtual = new Date();
    const isSameDate = dataAtual.setHours(0, 0, 0, 0) <= this.dataReferencia.setHours(0, 0, 0, 0);
    const isBeforeDate = dataAtual.setHours(0, 0, 0, 0) < this.dataReferencia.setHours(0, 0, 0, 0);
    // console.log(isSameDate)
    // console.log(isBeforeDate)
    if ((this.isAdminEnabled && isSameDate) || (this.isMpEnabled && item.fornecedor == "" && item.mpCode == "" && item.volumes == "") && isBeforeDate) {
      this.item = { ...item };
      this.item.indice = i;
      this.item.pecasCritica = this.item.pecasCritica || [];
      this.dialogOpen = true;
    } else {
      const confirmacao = window.confirm("Ação não permitida!\nCaso necessite fazer alguma alteração nesta viagem, entre em contato com o coordenador de transporte responsável.\nSSBVAD");
      if (confirmacao) { }
    }
  }

  adicionarPecasCritica() {
    this.item.pecasCritica.push({ PN: '', quantidade: 0 });
  }

  removerPecasCritica(index: number) {
    this.item.pecasCritica.splice(index, 1);
  }

  selecionarTexto(event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
  }

  async salvar2() {
    // console.log(this.item)
    const currentDate = new Date().getTime();
    this.isLoading = true;
    if (!this.item.ID || this.item.ID == undefined || this.item.ID == null || this.item.ID == '') {
      this.item.ID = this.item.indice;
      const time = Date.now();
      this.item.ID = `${this.item.ID}${time}`;
      this.item.created = currentDate.toString();
      this.item.createdBy = this.usuarioLogado.id;
      this.item.date =  new Date();
    } else {
      this.item.ID = this.item.ID
    }
    this.item.tableName = this.queryDiretasLcbExtras
    this.item.origemExtraLCB = true
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray);

    await this.dynamodbService.salvar(jsonArray, this.item.tableName, this.urlAtualiza).subscribe(async response => {
      this.filtro = false;
      this.startDate = new Date();
      await this.upDate();
      await this.salvarNaTimeTable();
      // //console.log(response)
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  cancel(): void {
    this.dialogOpen = false;
  }

  async getDiretasExtras(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": this.queryDiretasLcbExtras,
        "searchConditions": [
          // { "column": "status", "word": "Completed", "negate": true },
          // { "column": "status", "word": "Canceled", "negate": true },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true },
          // { "column": "ID", "word": "", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = await JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.viagensDiretasExtras = items;
            // console.log(this.viagensDiretasExtras)
            this.viagensDiretasExtrasZerada.forEach((novaViagem, index) => {
              const indiceExistente = this.viagensDiretasExtras.findIndex(
                viagem => viagem.indice === novaViagem.indice && (viagem.dataSolicitacao === novaViagem.dataSolicitacao || viagem.dataSolictacao === novaViagem.dataSolicitacao)
              );
              if (indiceExistente !== -1) {
                this.viagensDiretasExtrasZerada[index] = this.viagensDiretasExtras[indiceExistente];
              }
            });
            this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasZerada.filter(item => {
              const dataString = item.dataSolicitacao ? item.dataSolicitacao : item.dataSolictacao ;
              const dataDate = new Date(this.dataReferencia).toISOString().split('T')[0];
              // console.log(dataString)
              // console.log(dataDate)
              return dataString === dataDate
            });

            this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasFiltrados.sort((a, b) => {
              const horaA = new Date('1970-01-01T' + a.horaJanela).getTime(); // Convertendo para milissegundos
              const horaB = new Date('1970-01-01T' + b.horaJanela).getTime(); // Convertendo para milissegundos                
              return horaA - horaB;
            });

            // console.log(this.viagensDiretasExtras)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }

    } catch (error: any) {
      console.error(error);
    }
  }

  async getPlacesFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.queryFornecedores, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.places = items;
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getMPsFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.queryMPs, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.mps = items;
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async aplicarFiltro(): Promise<void> {
    // console.log("filtro")
    this.desabilitado = new Date(this.startDate) < new Date()
    // console.log(new Date(this.startDate))
    // console.log(new Date())
    // console.log(this.desabilitado)
    this.filtro = true;
    // console.log(this.startDate)
    let dataRef = new Date(this.startDate  + 'T12:00:00');
    await this.resetaVariavel(dataRef);
    // console.log(this.viagensDiretasExtrasZerada)
    this.viagensDiretasExtrasZerada.forEach((novaViagem, index) => {
      console.log(novaViagem)
      console.log(this.viagensDiretasExtras)
      const indiceExistente = this.viagensDiretasExtras.findIndex(
        viagem => viagem.indice === novaViagem.indice && (viagem.dataSolicitacao === novaViagem.dataSolicitacao || viagem.dataSolictacao === novaViagem.dataSolicitacao)
      );
      // console.log(indiceExistente)

      if (indiceExistente !== -1) {
        // console.log(this.viagensDiretasExtras[indiceExistente])
        this.viagensDiretasExtrasZerada[index] = this.viagensDiretasExtras[indiceExistente];
      }
    });
    this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasZerada.filter(item => {
      const dataString = item.dataSolicitacao ? item.dataSolicitacao : item.dataSolictacao ;
      const dataDate = new Date(this.startDate).toISOString().split('T')[0];
      // console.log(dataString)
      // console.log(dataDate)
      return dataString === dataDate
    });

    this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasFiltrados.sort((a, b) => {
      const horaA = new Date('1970-01-01T' + a.horaJanela).getTime(); // Convertendo para milissegundos
      const horaB = new Date('1970-01-01T' + b.horaJanela).getTime(); // Convertendo para milissegundos                
      return horaA - horaB;
    });
    await this.somaMU();
    console.log(this.viagensDiretasExtrasFiltrados)

  }

  async limpaData() {
    this.filtro = false;
    // console.log(this.dataReferencia)
    this.startDate = new Date();
    await this.upDate();
  }

  somaMU() {
    this.totalMU = 0;
    this.totalFornecedores = 0;
    if (this.viagensDiretasExtrasFiltrados) {
      this.viagensDiretasExtrasFiltrados.forEach(item => {
        if (item.volumes > 0) {
          this.totalMU += parseFloat(item.volumes)
          this.totalFornecedores++;
        }
      })
    }
  }

  verificarMPCode(item: any): void {
    const mpCodeUpperCase = item.mpCode.toUpperCase();
    const MP = this.mps.find(listaMP => listaMP.MPCode == mpCodeUpperCase);
    if (MP) {
      item.mpName = MP.MPName;
    } else {
      item.mpName = "";
    }
  }

  verificarFornecedor(item: any): void {
    const supCodeUpperCase = item.codFronecedor.toUpperCase();
    const forn = this.places.find(place => place.SupplierNumber === supCodeUpperCase);
    if (forn) {
      item.fornecedor = forn.SupplierName;
    } else {
      item.fornecedor = "";
    }
  }

  verificarFornecedorNome(item: any): void {
    const supNameUpperCase = item.fornecedor.toUpperCase();
    const forn = this.places.find(place => place.SupplierName.includes(supNameUpperCase));
    if (forn) {
      item.fornecedor = forn.SupplierName;
    } else {
      item.fornecedor = "";
    }
  }

  async getUserLogado(): Promise<UsuarioLogado> {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    let usuario = await this.autenticacaoService.obterUsuarioLogado()
    return usuario;
    // //console.log(this.usuarioLogado)
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    } else if (this.usuarioLogado.role == '1' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' || this.usuarioLogado.role == '8') {
    // } else if (this.usuarioLogado.role == '1') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    } else if (this.usuarioLogado.role == '6') {
      this.isMpEnabled = true;
    }
    // console.log( this.usuarioLogado.role)
    // console.log( this.isAdminEnabled)
  }

  toggleEditMode(index: number): void {
    this.editMode[index] = !this.editMode[index];
  }
  toggleInformationMode(index: number): void {
    this.informationMode[index] = !this.informationMode[index];
  }

  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async salvarNaTimeTable() {
    // console.log(this.item)
    const dataHoraString = `${this.item.dataSolicitacao}T${this.item.horaJanela}:00.000Z`;
    const dataHora = new Date(dataHoraString);
    // console.log(dataHora)
    const formattedDate = dataHora.toISOString();
    // console.log(formattedDate)
    this.isLoading = true;
    const currentDate = new Date().getTime()
    this.item = {
      ...this.item,
      "ID": this.item.ID,
      "lastUpdate": new Date(),
      "dataJanelaTimeTable": this.item.dataSolicitacao,
      "dataJanela": this.item.dataSolicitacao,
      "horaJanelaTimeTable": this.item.horaJanela,
      "JanelaDestino 1": formattedDate,
      // "Janela": formattedDate,
      // "jan1": formattedDate,
      "Plate": this.item.Plate,
      "Volumes": this.item.volumes,
      'Fornecedor 1': this.item.fornecedor,
      'Fornecedores': this.item.fornecedor,
      "tableName": this.queryTimeTable,
      'area': this.item.localRecebimento,
      'prioridade': this.item.pecasCritica ? true : false,
      "Transportadora": "DIRETO EXTRA",
      'Destino 1': 'LCB'
    }
    console.log(this.item)
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      await this.upDate();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async deleteItem(ID: string): Promise<void> {
    if (this.isAdminEnabled) {
      const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
      if (confirmacao) {
        this.isLoading = true;
        await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryDiretasLcbExtras).subscribe(
          async response => {
            this.startDate = new Date();
            await this.upDate();
            await this.deleteItemTimeTable(ID);
            this.isLoading = false;
          },
          error => {
            // Lógica para lidar com erros durante a deleção do item
          }
        );
      }
    } else {
      const confirmacao = window.confirm("Ação não permitida!");
      if (confirmacao) { }
    }
  }

  async deleteItemTimeTable(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryTimeTable).subscribe(
        async response => {
          console.log("Deletado da tabela de extra LCB")
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }
}
